/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromSearch from 'app/shared/store/actions/search.action';

export interface SearchState {
  searchTerm: string;
}

export const initialState = {
  searchTerm: '',
};

export function reducer(state = initialState, action: fromSearch.SearchAction): SearchState {
  if (action.type === fromSearch.SET_SEARCH_TERM) {
    return {
      ...state,
      searchTerm: action.payload,
    };
  }
  return state;
}

export const getSearchTerm = (state: SearchState) => state.searchTerm;
